import Stock from './views/Stock.vue'

const route = [
  {
    path: '/stocks',
    name: 'stock',
    component: Stock,
    meta: {
      layout: 'default',
      auth: true,
      menu: true,
      title: 'Stocks',
      role: ['A','R','C','I'],
      lang_code: 'stocks',
      customer_required: true,
      order: 7
    }
  }
]

export default route